import custom from './custom'
import plat from './plat'
import enroll from './enroll'
import portal from './portal'
import domain from './domain'

const pageRouters = [
  custom,
  plat,
  enroll,
  ...portal,
  ...domain
]

export default pageRouters
